import { Checkbox, Divider, List, Space, Typography } from 'antd'
import _ from 'lodash'
import { Dispatch, FC, SetStateAction, useCallback } from 'react'
import styled from 'styled-components'

import { DrilldownTableColumnListEditor } from './DrilldownTableColumnListEditor'
import { useDrilldownTableConfig } from './DrilldownTableConfigContext'
import { SchemaTypeSelect } from './SchemaTypeSelect'

const { Title } = Typography

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
`

export const DrilldownTableConfigPanel: FC = () => {
  const {
    groupByType,
    setGroupByType,
    enabledExtraColumnIds,
    setEnabledExtraColumnIds,
    extraColumns,
    showFocusColumn,
    setShowFocusColumn,
  } = useDrilldownTableConfig()

  const extraColumnEnabledSetter = useCallback<
    (id: string) => Dispatch<SetStateAction<boolean>>
  >(
    (id) => (enabled: SetStateAction<boolean>) =>
      setEnabledExtraColumnIds?.((prevEnabledIds) => {
        const prevEnabled = prevEnabledIds.includes(id)
        const newEnabled =
          typeof enabled === 'function' ? enabled(prevEnabled) : enabled
        if (newEnabled === prevEnabled) {
          return prevEnabledIds
        }
        return newEnabled
          ? _.uniq([...prevEnabledIds, id])
          : prevEnabledIds.filter((prevId) => prevId !== id)
      }),
    [setEnabledExtraColumnIds]
  )

  return (
    <Container>
      <Title level={3}>Options</Title>
      <Divider />
      <Space
        style={{
          width: '100%',
          justifyContent: 'center',
          marginTop: 16,
        }}>
        <Container>
          <SchemaTypeSelect
            label='Group By'
            selectedType={groupByType}
            setSelectedType={setGroupByType}
          />
          <Checkbox
            checked={showFocusColumn}
            disabled={!setShowFocusColumn}
            onChange={({ target: { checked } }) =>
              setShowFocusColumn?.(checked)
            }>
            Show focus column
          </Checkbox>
        </Container>
      </Space>
      <Title level={3}>Columns</Title>
      <Divider />
      <DrilldownTableColumnListEditor />
      {setEnabledExtraColumnIds && !!extraColumns.length && (
        <>
          <Title level={3}>Special Columns</Title>
          <Divider />
          <Space
            style={{
              width: '100%',
              justifyContent: 'center',
              marginTop: 16,
            }}>
            <List
              bordered
              dataSource={[...extraColumns]}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Checkbox
                      key={'checkboxEnabled'}
                      checked={enabledExtraColumnIds.includes(item.id)}
                      onChange={({ target: { checked } }) =>
                        extraColumnEnabledSetter(item.id)(checked)
                      }
                    />,
                  ]}>
                  {item.name}
                </List.Item>
              )}
            />
          </Space>
        </>
      )}
    </Container>
  )
}
